import React from 'react'
import styled from 'styled-components'
import { colors } from 'theme/default'
import Checkbox from 'components/Checkbox'

const Container = styled.div`
  position: relative;
  width: 55px;
  height: 28px;
  border-radius: 14px;
  background-color: ${props => props.checked ? colors.toggleOn : colors.toggleOff};
  padding: 2px;
  transition: background-color 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
`

const Toggle = styled.div`
  position: absolute;
  left: ${props => props.checked ? 'calc(100% - 26px)' : '2px'};
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: #fff;
  transition: left 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: -1px 0 3px 0 rgba(0, 0, 0, 0.35);
`

const Switch = (props) => (
  <Checkbox {...props}>
    {({ checked, disabled }) => (
      <Container checked={checked} >
        <Toggle checked={checked} />
      </Container>
    )}
  </Checkbox>
)

export default Switch
